module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/06_shape-sm-c0c1142f71076fcb0b2c7c9ee6c16068.png";